import React, { useCallback, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Checkbox, Form, message, Tag } from 'antd';

import ReusableModal from '../../../../components/ReusableComponents/ReusableModal';
import ActionButton from '../../../../components/ActionButton';

import { BatchRejectionContainer } from './styles';
import { InputContainer, ModalTagContainer } from '../../../../components/Modals/styles';

import { BATCH_REJECTION_MODAL as trans } from '../TranslationValues';

import { Input } from 'antd';
import regex from '../../../../utils/regex';
const { TextArea } = Input;

const NAMESPACES = ['BATCH_REJECTION_MODAL'];

const BatchRejectionModal = ({ visible, setRejectionModal, processJobApproval, buttonContainerRef, t, ...props }) => {
  const [mailAddress, setMailAddress] = useState([]);
  const [rejectionReason, setRejectionReason] = useState('');
  const [isNotified, setIsNotified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const buttonContainer = buttonContainerRef?.current?.getBoundingClientRect();
  const modalPosition = window.innerHeight-buttonContainer?.top;

  const handleCheckboxChange = () => {
    setIsNotified(!isNotified);
  };

  const handleInputChange = useCallback(
    event => {
      event.preventDefault();
      const inputVal = event.target.value.trim();
      if (inputVal.length < 1) {
        return;
      }
      const isValidEmailID = regex.EMAIL.test(inputVal);
      if (isValidEmailID) {
        if (mailAddress.includes(inputVal)) {
          message.error(t(trans.EMAIL_ID_EXISTS_ERROR.key, trans.EMAIL_ID_EXISTS_ERROR.value));
        } else {
          setInputValue('');
          setMailAddress(prev => [...prev, inputVal]);
        }
      } else {
        message.warning(t(trans.INVALID_EMAIL_ID_ERROR.key, trans.INVALID_EMAIL_ID_ERROR.value));
      }
    },
    [mailAddress],
  );

  const handleClose = useCallback(
    emailId => {
      const emailIds = mailAddress.filter(id => id !== emailId);
      setMailAddress(emailIds);
    },
    [mailAddress],
  );

  const handleRejection = useCallback(
    (e, emailId) => {
      e.preventDefault();
      const inputVal = emailId.trim();
      const emailIds = [ ...mailAddress ];
      if (regex.EMAIL.test(inputVal)) {
        emailIds.push(inputVal);
      }
      props.form.validateFields(async err => {
        if (!err) {
          if (isNotified && emailIds.length === 0) {
            message.warning(t(trans.ENTER_EMAIL_ADDRESS.key, trans.ENTER_EMAIL_ADDRESS.value));
            return;
          }
          const reason = rejectionReason.trim();
          const additionalPayload = {
            approvalType: 'reject',
            rejectReason: reason,
            email: emailIds,
          };
          setLoading(true);
          processJobApproval(true, additionalPayload, () => setLoading(false));
        }
      });
    },
    [isNotified, mailAddress, rejectionReason],
  );

  const { getFieldDecorator } = props.form;

  return (
    <ReusableModal
      visible={visible}
      title={t(trans.BATCH_REJECTION_MODAL_HEADER.key, trans.BATCH_REJECTION_MODAL_HEADER.value)}
      onCancel={() => setRejectionModal(false)}
      footer={null}
      className="batchRejection"
      styleProps={{
        bottom: `${modalPosition}px`,
      }}
    >
      <BatchRejectionContainer>
        <Form>
          <Form.Item>
            {getFieldDecorator('comment', {
              rules: [{ 
                required: true, 
                message: t(trans.REJECT_REASON_REQUIRED_ERROR.key, trans.REJECT_REASON_REQUIRED_ERROR.value) }],
            })(
              <TextArea
                autosize={{ minRows: 5, maxRows: 5 }}
                placeholder={t(
                  trans.JOB_REJECTION_PLACEHOLDER.key,
                  trans.JOB_REJECTION_PLACEHOLDER.value,
                )}
                onChange={e => setRejectionReason(e.target.value)}
              />,
            )}
          </Form.Item>
          <Checkbox onChange={handleCheckboxChange} className="m-10">
            {t(trans.NOTIFY_USER_LABEL.key, trans.NOTIFY_USER_LABEL.value)}
          </Checkbox>

          {isNotified &&
            <ModalTagContainer border={true} className="m-10 emailBox">
              {mailAddress.map((emailAddress, index) => {
                return (
                  <Tag
                    className="edit-tag"
                    key={emailAddress}
                    closable={true}
                    color="#df4c35"
                    onClose={() => handleClose(emailAddress)}
                  >
                    <span title={emailAddress}>{emailAddress}</span>
                  </Tag>
                );
              })}
              <InputContainer tagInput>
                <Input
                  name="emailAddress"
                  type="text"
                  className="tag-input"
                  value={inputValue}
                  placeholder={t(
                    trans.ENTER_MAIL_ADDRESS_PLACEHOLDER.key,
                    trans.ENTER_MAIL_ADDRESS_PLACEHOLDER.value,
                  )}
                  onChange={e => setInputValue(e.target.value)}
                  onPressEnter={handleInputChange}
                  autoComplete={'off'}
                />
              </InputContainer>
            </ModalTagContainer>
          }
          <div className="actionButton">
            <ActionButton
              medium
              label={t(trans.REJECTION_ACTION_BUTTON.key, trans.REJECTION_ACTION_BUTTON.value)}
              onClick={(e) => handleRejection(e, inputValue)}
              maxLength={5000}
              backgroundColor={'ghost'}
              fontColor={'secondary'}
              loading={loading}
              enableShadow
            />
          </div>
        </Form>
      </BatchRejectionContainer>
    </ReusableModal>
  );
};

const BatchRejection = Form.create({ name: 'batch_rejection' })(BatchRejectionModal);
export default withTranslation(NAMESPACES)(BatchRejection);
